import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilter, ISortModel } from "../interfaces/INotificationLog";

export type INotificationLogSlice = {
    notificationLog: Array<any>
    showNotificationButton: boolean,
    filters: IFilter[],
    furnaceNotificationLog: any, 
    notificationHistory: any,
    pagination: {page: string, pageSize: string},
    sortModel: ISortModel[],
    apiResultStatus: boolean,
    isFilterOpen: boolean
}

const initialState: INotificationLogSlice = {
    notificationLog: [],
    showNotificationButton : true,
    filters:[],
    furnaceNotificationLog: [],
    notificationHistory: {
        rows: [],
        totalRowCount: 0
    },
    pagination: {
        page: '1',
        pageSize: '20'
    },
    sortModel:[],
    apiResultStatus : false,
    isFilterOpen: false
}

export const notificationLogSlice = createSlice({
    name: 'notificationLogSlice',
    initialState: initialState,
    reducers: {
        setNotificationLog: (state, action: PayloadAction<any[]>) => {
            state.notificationLog = action.payload;
        },
        resetNotificationLog: (state) => {
            state.notificationLog = initialState.notificationLog
        },
        setNotificationButton: (state, action: PayloadAction<boolean>) => {
            state.showNotificationButton = action.payload
        },
        setNotificationLogFilters: (state, action: PayloadAction<IFilter>) => {
            state.filters = state.filters.filter(f => f.field !== action.payload.field)
            if(action.payload.value) {
                state.filters.push(action.payload)
            } 
            //persist for setInterval func
            sessionStorage.setItem('notificationLogFilters', JSON.stringify(state.filters));
        },
        setFurnaceNotificationLog: (state, action: PayloadAction<any>) => {
            state.furnaceNotificationLog = action.payload    
        },
        resetNotificaitonFilterLog: (state) => {
            state.filters = initialState.filters
            sessionStorage.setItem('notificationLogFilters', JSON.stringify(state.filters));
        }, 
        setNotificationHistory: (state, action: PayloadAction<any>) => {            
            state.notificationHistory = action.payload    
        },
        resetNotificationHistory: (state) => {
            state.notificationHistory = initialState.notificationHistory
        },
        setPagination: (state, action: PayloadAction<any>) => {
            state.pagination = action.payload
        }, 
        resetPagination: (state) => {
            state.pagination = initialState.pagination
        },
        setSortModel: (state, action: PayloadAction<any>) => {
            state.sortModel = state.sortModel.filter(
                item => item.field !== action.payload.field
              );
              if(state.sortModel.length < 3) {
                state.sortModel.push(action.payload)
              }
            sessionStorage.setItem('notificationLogSortModel', JSON.stringify(state.sortModel));
        },
        resetSortModel: (state) => {
            state.sortModel = initialState.sortModel
            sessionStorage.setItem('notificationLogSortModel', JSON.stringify(state.sortModel));
        },
        setApiResultStatus: (state, action: PayloadAction<any>) => {
            state.apiResultStatus = action.payload
        },
        clearFieldSearch:(state, action: PayloadAction<string>) => {
            state.filters = state.filters.filter((f) => f.field !== action.payload);
            sessionStorage.setItem('notificationLogFilters', JSON.stringify(state.filters));
        }, 
        clearColumnSort: (state, action: PayloadAction<string>) => {
            state.sortModel = state.sortModel.filter(s => s.field !== action.payload);
            sessionStorage.setItem('notificationLogSortModel', JSON.stringify(state.sortModel));
        },
        setIsFilterOpen: (state, action: PayloadAction<boolean>) => {
            state.isFilterOpen = action.payload
        }
    }
})

export const {
    setNotificationLog,
    resetNotificationLog,
    setNotificationButton,
    setNotificationLogFilters,
    setFurnaceNotificationLog,
    resetNotificaitonFilterLog,
    setNotificationHistory,
    setPagination,
    resetPagination,
    setSortModel,
    resetSortModel,
    resetNotificationHistory,
    setApiResultStatus,
    clearFieldSearch, 
    clearColumnSort,
    setIsFilterOpen
} = notificationLogSlice.actions


export default notificationLogSlice.reducer